import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchAgroExporterBrands(agro_exporter_process_id) {
    return RequesterV1.get(
      `agro_exporter/production/basic_container_export/manage_container_planning/fetch_agro_exporter_brands/${agro_exporter_process_id}`
    );
  },
  fetchCropSizes(agro_exporter_process_id) {
    return RequesterV1.get(
      `agro_exporter/production/basic_container_export/manage_container_planning/fetch_crop_sizes/${agro_exporter_process_id}`
    );
  },
  fetchContainer(container_id) {
    return RequesterV1.get(
      `agro_exporter/production/basic_container_export/manage_container_planning/fetch_container/${container_id}`
    );
  },
  fetchContainerPlanning(container_id) {
    return RequesterV1.get(
      `agro_exporter/production/basic_container_export/manage_container_planning/fetch_container_planning/${container_id}`
    );
  },
  create({container_id, container_planning, package_plannings = [], package_group_plannings = []}) {
    return RequesterV1.post(
      `agro_exporter/production/basic_container_export/manage_container_planning/create/${container_id}`,
      {
        container_planning,
        package_plannings,
        package_group_plannings,
      }
    );
  },
  update({container_id, container_planning, package_plannings = [], package_group_plannings = []}) {
    return RequesterV1.post(
      `agro_exporter/production/basic_container_export/manage_container_planning/update/${container_id}`,
      {
        container_planning,
        package_plannings,
        package_group_plannings,
      }
    );
  },
};
